import React, { useState, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import UniversitiesPublic from "./UniversitiesPublic";
import InstitutesPublic from "./InstitutesPublic";
import PublicNavBar from "../components/PublicNavBar";
import PublicFooter from "../components/PublicFooter";
import { Building2, School } from "lucide-react";

const TABS = [
  { key: "university", label: "Universities", Icon: Building2,
    blurb: "For deans, registrars and TPOs of universities." },
  { key: "college",    label: "Colleges & Institutes", Icon: School,
    blurb: "For affiliated colleges, polytechnics and training institutes." },
];

export default function InstitutionsPublic() {
  const [sp, setSp] = useSearchParams();
  const initial = useMemo(() => {
    const t = sp.get("tab");
    if (t && TABS.find(x => x.key === t)) return t;
    return "university";
  }, [sp]);
  const [tab, setTab] = useState(initial);

  useEffect(() => {
    if (sp.get("tab") !== tab) {
      const next = new URLSearchParams(sp);
      next.set("tab", tab);
      setSp(next, { replace: true });
    }
  }, [tab, sp, setSp]);

  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [tab]);

  return (
    <div className="min-h-screen bg-white text-ink" data-testid="institutions-public">
      <PublicNavBar primaryCta={{ to: "/signup?role=institute", label: "Get started" }} />

      <div className="sticky top-[60px] z-30 bg-paper border-b border-rule" data-testid="institutions-tab-strip">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-3 flex flex-wrap items-center gap-2">
          <span className="eyebrow mr-2">I am from a:</span>
          {TABS.map(t => {
            const active = tab === t.key;
            const Icon = t.Icon;
            return (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                data-testid={`institutions-tab-${t.key}`}
                className={`text-xs font-bold px-3 py-1.5 rounded-full border transition inline-flex items-center gap-1.5 ${
                  active ? "bg-signal text-white border-signal"
                         : "border-rule text-muted hover:border-signal hover:text-signal"
                }`}
              >
                <Icon size={12}/> {t.label}
              </button>
            );
          })}
          <span className="hidden md:inline text-xs text-muted ml-2">
            · {TABS.find(t => t.key === tab)?.blurb}
          </span>
        </div>
      </div>

      {tab === "university" ? <UniversitiesPublic embedded /> : <InstitutesPublic embedded />}

      <PublicFooter />
    </div>
  );
}
